var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"stars",class:{'stars-small': _vm.small}},[_c('div',_vm._l((_vm.count),function(star){return _c('tl-icon',{key:`fas-${star}`,class:{ 'stars__additional-star': star > _vm.getCountStarts },attrs:{"icon":['fas', 'star']}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }